import accountIdReducer from './accountIdReducer';

const rootReducer = {
	accountIdReducer
};

export default rootReducer;
